export default __webpack_public_path__ + "static/media/lastofusep5003.cf0ff6ea.jpg";